export default __webpack_public_path__ + "static/media/rarity-nobg.08a24512.png";